import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';

function EsteticaFooter() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isCancellationOpen, setIsCancellationOpen] = useState(false);

  return (
    <footer className="text-gray-800 py-16 px-4 pb-8 relative overflow-hidden border-t-4 border-green-300/70 z-10 mt-auto">
      {/* Fondo transparente para que se vea el fondo de los tratamientos */}
      <div className="absolute inset-0 bg-white/80 backdrop-blur-sm"></div>

              <div className="container mx-auto grid grid-cols-1 lg:grid-cols-4 gap-8 items-start relative z-20 max-w-6xl">
          {/* Columna 1: Información de Contacto */}
          <div className="text-center lg:text-left">
            <h3 className="text-xl font-bold mb-4 pb-2 relative inline-block font-serif">
              <span className="relative z-10 text-green-800">
                Cleo Estética
              </span>
              <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-300 to-teal-400 -z-0"></span>
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-green-100/80 backdrop-blur-sm p-2 rounded-lg mr-4 shadow-sm">
                  <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
                <p className="text-gray-900 text-sm font-medium drop-shadow-sm">Av. Mcal. López 1234, Caacupé, Paraguay</p>
              </div>
              <div className="flex items-start">
                <div className="bg-teal-100/80 backdrop-blur-sm p-2 rounded-lg mr-4 shadow-sm">
                  <svg className="w-5 h-5 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                  </svg>
                </div>
                <div className="text-left">
                  <p className="text-gray-900 text-sm font-medium drop-shadow-sm">Tel: +595 986 523658</p>
                  <p className="text-gray-900 text-sm font-medium drop-shadow-sm">WhatsApp: +595 986 523658</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-emerald-100/80 backdrop-blur-sm p-2 rounded-lg mr-4 shadow-sm">
                  <svg className="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                  </svg>
                </div>
                <p className="text-gray-900 text-sm font-medium drop-shadow-sm">cleoestetica00@gmail.com</p>
              </div>
            </div>
          </div>

        {/* Columna 2: Horario de Atención */}
        <div className="text-center lg:text-left">
          <h3 className="text-xl font-bold mb-4 pb-2 relative inline-block font-serif">
            <span className="relative z-10 text-green-800">
              Horario
            </span>
            <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-300 to-teal-400 -z-0"></span>
          </h3>
          <div className="space-y-4">
            <div className="flex justify-between items-center bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm border border-white/30">
              <span className="text-gray-900 text-sm font-medium drop-shadow-sm">Lunes - Viernes</span>
              <span className="text-gray-800 font-semibold text-sm bg-green-100/80 backdrop-blur-sm px-3 py-1 rounded-full drop-shadow-sm">9:00 - 18:30</span>
            </div>
            <div className="flex justify-between items-center bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm border border-white/30">
              <span className="text-gray-900 text-sm font-medium drop-shadow-sm">Sábados</span>
              <span className="text-gray-800 font-semibold text-sm bg-teal-100/80 backdrop-blur-sm px-3 py-1 rounded-full drop-shadow-sm">9:00 - 14:00</span>
            </div>
            <div className="flex justify-between items-center bg-white/80 backdrop-blur-sm p-3 rounded-lg shadow-sm border border-white/30">
              <span className="text-gray-900 text-sm font-medium drop-shadow-sm">Domingos</span>
              <span className="text-gray-800 font-semibold text-sm bg-gray-100/80 backdrop-blur-sm px-3 py-1 rounded-full drop-shadow-sm">Cerrado</span>
            </div>
          </div>
        </div>

        {/* Columna 3: Enlaces Rápidos */}
        <div className="text-center lg:text-left">
          <h3 className="text-xl font-bold mb-4 pb-2 relative inline-block font-serif">
            <span className="relative z-10 text-green-800">
              Información
            </span>
            <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-300 to-teal-400 -z-0"></span>
          </h3>
          <div className="space-y-4">
            <button 
              onClick={() => setIsPrivacyOpen(true)}
              className="flex items-center text-gray-900 hover:text-green-600 text-sm font-medium w-full transition-colors group bg-white/60 backdrop-blur-sm p-3 rounded-lg hover:bg-white/80 border border-white/30 drop-shadow-sm"
            >
              <svg className="w-4 h-4 mr-3 text-green-500 group-hover:animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
              Política de Privacidad
            </button>
            <button 
              onClick={() => setIsTermsOpen(true)}
              className="flex items-center text-gray-900 hover:text-green-600 text-sm font-medium w-full transition-colors group bg-white/60 backdrop-blur-sm p-3 rounded-lg hover:bg-white/80 border border-white/30 drop-shadow-sm"
            >
              <svg className="w-4 h-4 mr-3 text-green-500 group-hover:animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
              Términos y Condiciones
            </button>
            <button 
              onClick={() => setIsCancellationOpen(true)}
              className="flex items-center text-gray-900 hover:text-green-600 text-sm font-medium w-full transition-colors group bg-white/60 backdrop-blur-sm p-3 rounded-lg hover:bg-white/80 border border-white/30 drop-shadow-sm"
            >
              <svg className="w-4 h-4 mr-3 text-green-500 group-hover:animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"/>
              </svg>
              Política de Cancelación
            </button>
          </div>
        </div>

        {/* Columna 4: Mapa y Redes Sociales */}
        <div className="space-y-6">
          {/* Mapa */}
          <div>
            <h3 className="text-xl font-bold mb-4 pb-2 relative inline-block font-serif">
              <span className="relative z-10 text-green-800">
                Ubicación
              </span>
              <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-300 to-teal-400 -z-0"></span>
            </h3>
            <div className="w-full h-40 bg-white/80 backdrop-blur-sm rounded-xl overflow-hidden shadow-lg border border-white/30 transform transition-all duration-500 hover:shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3618.899190554349!2d-57.1314728!3d-25.3819187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x945c33864f20d25d%3A0xa08fca83755ac50b!2sCleo%20est%C3%A9tica%20facial%20y%20corporal!5e0!3m2!1ses!2spy!4v1718300000000!5m2!1ses!2spy"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación de Cleo Estética"
                className="opacity-90 hover:opacity-100 transition-opacity duration-300"
              ></iframe>
            </div>
          </div>
          
          {/* Redes Sociales */}
          <div>
            <h3 className="text-xl font-bold mb-4 pb-2 relative inline-block font-serif">
              <span className="relative z-10 text-green-800">
                Conéctate
              </span>
              <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-green-300 to-teal-400 -z-0"></span>
            </h3>
            <div className="flex justify-center lg:justify-start space-x-6">
              <a href="https://facebook.com/cleo.estetica20" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-blue-600 transition-colors duration-300 transform hover:scale-110">
                <div className="bg-blue-100/80 backdrop-blur-sm p-3 rounded-full shadow-sm border border-white/30">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.776-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33V22C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                  </svg>
                </div>
              </a>
              <a href="https://instagram.com/cleo_estetica20" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-pink-600 transition-colors duration-300 transform hover:scale-110">
                <div className="bg-pink-100/80 backdrop-blur-sm p-3 rounded-full shadow-sm border border-white/30">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 3.807.058h.468c2.456 0 2.784-.011 3.807-.058.975-.045 1.504-.207 1.857-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-3.807v-.468c0-2.456-.011-2.784-.058-3.807-.045-.975-.207-1.504-.344-1.857a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                  </svg>
                </div>
              </a>
              <a href="https://wa.me/+595986523658" target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-green-600 transition-colors duration-300 transform hover:scale-110">
                <div className="bg-green-100/80 backdrop-blur-sm p-3 rounded-full shadow-sm border border-white/30">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

                  {/* Copyright */}
            <div className="w-full text-center text-gray-800 text-sm py-6 mt-12 relative z-20 border-t border-gray-200">
              <div className="container mx-auto max-w-6xl space-y-2">
                <p className="font-medium text-gray-900">© 2026 Cleo Estética. Todos los derechos reservados.</p>
                <p className="text-emerald-800 font-medium">Estética facial y corporal · Caacupé, Cordillera</p>
                <div className="pt-2">
                  <p className="font-semibold text-green-900 text-base">¿Querés reservar tu cita?</p>
                  <p className="text-gray-700 font-light">Escribinos y consultá la disponibilidad.</p>
                </div>
                <p className="font-light text-xs text-gray-500 pt-4">
                  Desarrollado por{" "}
                  <a 
                    href="https://marcosgnbsoft.onrender.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 underline transition-colors duration-200"
                  >
                    mgnb
                  </a>
                </p>
              </div>
            </div>

      {/* Modal de Política de Privacidad */}
      <Dialog open={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} className="relative z-50">
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-2xl rounded-lg bg-white p-6 shadow-xl">
            <Dialog.Title className="text-xl font-bold text-gray-900 mb-4 font-serif">Política de Privacidad</Dialog.Title>
            <div className="prose prose-sm text-gray-700 max-h-[70vh] overflow-y-auto space-y-3">
              <p className="italic text-gray-600 bg-green-50 p-3 rounded-lg border border-green-100">
                En Cleo Estética valoramos y respetamos la privacidad de nuestros clientes. Esta política explica qué información podemos recopilar, para qué la utilizamos y cómo procuramos protegerla.
              </p>

              <h3 className="font-semibold text-green-800 text-base mt-4">1. Información que recopilamos</h3>
              <p>Podemos recopilar información que nos proporcionás voluntariamente cuando:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Solicitás o reservás una cita.</li>
                <li>Te comunicás con nosotros para realizar consultas.</li>
                <li>Solicitás información sobre nuestros tratamientos y servicios.</li>
                <li>Participás voluntariamente en promociones o actividades de Cleo Estética.</li>
              </ul>
              <p className="text-xs text-gray-500">La información puede incluir datos de contacto y aquellos datos necesarios para gestionar adecuadamente tu atención.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">2. Uso de la información</h3>
              <p>La información recopilada puede utilizarse para:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Gestionar y confirmar tus citas.</li>
                <li>Comunicarnos con vos en relación con tu reserva o consulta.</li>
                <li>Brindarte información sobre nuestros servicios.</li>
                <li>Mejorar la atención y experiencia ofrecida en Cleo Estética.</li>
                <li>Cumplir con las obligaciones legales que correspondan.</li>
              </ul>

              <h3 className="font-semibold text-green-800 text-base mt-4">3. Protección de tus datos</h3>
              <p>Adoptamos medidas razonables para proteger la información personal que nos proporcionás y evitar su acceso, modificación, divulgación o uso no autorizado.</p>
              <p>No compartimos tus datos personales con terceros, salvo cuando sea necesario para prestar un servicio solicitado, exista una obligación legal o contemos con tu autorización.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">4. Tus derechos</h3>
              <p>Podés solicitar información sobre los datos personales que conservamos de vos y, cuando corresponda, solicitar su actualización, rectificación o eliminación.</p>
              <p>Para realizar una consulta relacionada con tus datos personales, podés comunicarte directamente con Cleo Estética a través de nuestros canales de contacto.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">5. Actualizaciones</h3>
              <p>Esta política podrá ser actualizada cuando sea necesario para reflejar cambios en nuestros servicios, procesos o requisitos legales. Cualquier modificación será publicada en esta página.</p>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setIsPrivacyOpen(false)}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium"
              >
                Cerrar
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>

      {/* Modal de Términos y Condiciones */}
      <Dialog open={isTermsOpen} onClose={() => setIsTermsOpen(false)} className="relative z-50">
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-2xl rounded-lg bg-white p-6 shadow-xl">
            <Dialog.Title className="text-xl font-bold text-gray-900 mb-4 font-serif">Términos y condiciones de atención</Dialog.Title>
            <div className="prose prose-sm text-gray-700 max-h-[70vh] overflow-y-auto space-y-3">
              <h3 className="font-semibold text-green-800 text-base">1. Reservas y citas</h3>
              <p>Las citas en Cleo Estética se coordinan previamente a través de nuestros canales de contacto.</p>
              <p>Para determinados tratamientos o promociones puede solicitarse una seña para confirmar la reserva. En caso de corresponder, esta condición será informada al momento de agendar.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">2. Cancelaciones y cambios</h3>
              <p>Si necesitás cancelar o modificar tu cita, te pedimos avisarnos con al menos 24 horas de anticipación.</p>
              <p>Esto nos permite ofrecer ese horario a otra persona y organizar adecuadamente nuestra agenda.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">3. Puntualidad</h3>
              <p>Contamos con una tolerancia de 10 a 15 minutos. Pasado ese tiempo, la realización del tratamiento podrá verse afectada o será necesario reprogramar la cita, según la disponibilidad.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">4. Tratamientos</h3>
              <p>Los tratamientos se realizan de acuerdo con las características y necesidades de cada persona.</p>
              <p>Los resultados pueden variar según factores individuales, hábitos, constancia y respuesta de cada cuerpo o piel.</p>
              <p>Cuando un tratamiento requiera una valoración previa, esta se realizará antes de comenzar.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">5. Información importante</h3>
              <p>Para brindarte una atención adecuada, es importante informar previamente sobre cualquier condición de salud, alergia, medicación, embarazo u otra circunstancia que pueda ser relevante para el tratamiento.</p>
              <p>En caso de que una situación requiera valoración o atención médica, se recomendará consultar con el profesional correspondiente.</p>

              <h3 className="font-semibold text-green-800 text-base mt-4">6. Cuidados posteriores</h3>
              <p>Para acompañar adecuadamente el tratamiento, es importante seguir las recomendaciones de cuidado proporcionadas por Cleo Estética después de cada sesión.</p>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setIsTermsOpen(false)}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium"
              >
                Cerrar
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>

      {/* Modal de Política de Cancelación */}
      <Dialog open={isCancellationOpen} onClose={() => setIsCancellationOpen(false)} className="relative z-50">
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-2xl rounded-lg bg-white p-6 shadow-xl">
            <Dialog.Title className="text-xl font-bold text-gray-900 mb-4">Política de Cancelación</Dialog.Title>
            <div className="prose prose-sm text-gray-700 max-h-[70vh] overflow-y-auto">
              <h3 className="font-semibold">1. Cancelación por parte del cliente</h3>
              <p>Para cancelar o reprogramar una cita:</p>
              <ul className="list-disc pl-5">
                <li>Se requiere un aviso mínimo de 24 horas</li>
                <li>Las cancelaciones pueden realizarse por teléfono o WhatsApp</li>
                <li>Cancelaciones con menos de 24 horas pueden incurrir en un cargo del 50% del servicio</li>
              </ul>

              <h3 className="font-semibold mt-4">2. No presentación</h3>
              <p>Si no te presentas a tu cita sin previo aviso:</p>
              <ul className="list-disc pl-5">
                <li>Se aplicará un cargo del 100% del valor del servicio</li>
                <li>Para futuras citas, se podrá requerir pago anticipado</li>
              </ul>

              <h3 className="font-semibold mt-4">3. Cancelación por parte del centro</h3>
              <p>En raras ocasiones, podríamos necesitar cancelar o reprogramar tu cita debido a:</p>
              <ul className="list-disc pl-5">
                <li>Emergencias médicas del personal</li>
                <li>Problemas técnicos o de infraestructura</li>
                <li>Eventos de fuerza mayor</li>
              </ul>
              <p>En estos casos, te notificaremos lo antes posible y reprogramaremos tu cita sin cargo adicional.</p>

              <h3 className="font-semibold mt-4">4. Excepciones</h3>
              <p>Consideraremos excepciones a esta política en casos de:</p>
              <ul className="list-disc pl-5">
                <li>Emergencias médicas comprobables</li>
                <li>Eventos climáticos extremos</li>
                <li>Otras situaciones de fuerza mayor</li>
              </ul>
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setIsCancellationOpen(false)}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
              >
                Cerrar
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </footer>
  );
}

export default EsteticaFooter;